export interface Product {
  id: string
  name: string
  price: number
  category: string
  image: string
  altText: string
  isWIC: boolean
  isEBT: boolean
  description?: string
  origin?: string
}

export const categories = [
  'All',
  'Produce',
  'Grains & Flour',
  'Spices',
  'Proteins',
  'Beverages',
  'Snacks',
  'Canned Goods',
] as const

export type Category = (typeof categories)[number]

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Fresh Plantains (Ripe)',
    price: 1.49,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1603052875302-d376b7c0638a?auto=format&fit=crop&q=80&w=400',
    altText: 'Bunch of ripe yellow plantains',
    isWIC: true,
    isEBT: true,
    origin: 'Ghana',
  },
  {
    id: '2',
    name: 'Cassava (Fresh Yuca)',
    price: 2.99,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1598512752271-33f913a5af13?auto=format&fit=crop&q=80&w=400',
    altText: 'Fresh cassava roots',
    isWIC: true,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '3',
    name: 'Fufu Flour (Plantain)',
    price: 6.99,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?auto=format&fit=crop&q=80&w=400',
    altText: 'Bag of plantain fufu flour',
    isWIC: false,
    isEBT: true,
    origin: 'Ghana',
  },
  {
    id: '4',
    name: 'Palm Oil (Zomi)',
    price: 8.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&q=80&w=400',
    altText: 'Bottle of red palm oil',
    isWIC: false,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '5',
    name: 'Scotch Bonnet Peppers',
    price: 3.49,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1583119022894-919a68a3d0e3?auto=format&fit=crop&q=80&w=400',
    altText: 'Fresh scotch bonnet peppers',
    isWIC: true,
    isEBT: true,
    origin: 'Jamaica',
  },
  {
    id: '6',
    name: 'Egusi Seeds (Ground)',
    price: 7.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=400',
    altText: 'Ground egusi melon seeds',
    isWIC: false,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '7',
    name: 'Jollof Rice Seasoning',
    price: 4.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=400',
    altText: 'Jollof rice spice mix',
    isWIC: false,
    isEBT: true,
    origin: 'Ghana',
  },
  {
    id: '8',
    name: 'Dried Stockfish',
    price: 12.99,
    category: 'Proteins',
    image:
      'https://images.unsplash.com/photo-1544943910-4c1dc44aab44?auto=format&fit=crop&q=80&w=400',
    altText: 'Dried stockfish',
    isWIC: false,
    isEBT: true,
    origin: 'Norway',
  },
  {
    id: '9',
    name: 'Gari (Cassava Flakes)',
    price: 5.49,
    category: 'Grains & Flour',
    image:
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?auto=format&fit=crop&q=80&w=400',
    altText: 'Bag of gari cassava flakes',
    isWIC: false,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '10',
    name: 'Malt Drink (Malta)',
    price: 2.49,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1527960471264-932f39eb5846?auto=format&fit=crop&q=80&w=400',
    altText: 'Bottle of malta drink',
    isWIC: false,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '11',
    name: 'Chin Chin Snacks',
    price: 4.99,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?auto=format&fit=crop&q=80&w=400',
    altText: 'Bag of chin chin snacks',
    isWIC: false,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '12',
    name: 'Fresh Yams',
    price: 4.99,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1590165482129-1b8b27698780?auto=format&fit=crop&q=80&w=400',
    altText: 'Fresh African yams',
    isWIC: true,
    isEBT: true,
    origin: 'Ghana',
  },
  {
    id: '13',
    name: 'Coconut Milk',
    price: 3.29,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1550411294-875e5b4cc498?auto=format&fit=crop&q=80&w=400',
    altText: 'Can of coconut milk',
    isWIC: false,
    isEBT: true,
    origin: 'Thailand',
  },
  {
    id: '14',
    name: 'Suya Spice Mix',
    price: 5.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=400',
    altText: 'Suya spice blend',
    isWIC: false,
    isEBT: true,
    origin: 'Nigeria',
  },
  {
    id: '15',
    name: 'Callaloo (Canned)',
    price: 3.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1534483509719-3feaee7c30da?auto=format&fit=crop&q=80&w=400',
    altText: 'Can of callaloo greens',
    isWIC: false,
    isEBT: true,
    origin: 'Jamaica',
  },
  {
    id: '16',
    name: 'Ackee (Canned)',
    price: 6.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1534483509719-3feaee7c30da?auto=format&fit=crop&q=80&w=400',
    altText: 'Can of ackee fruit',
    isWIC: false,
    isEBT: true,
    origin: 'Jamaica',
  },
]

export const recipeBundles = [
  {
    id: 'bundle-1',
    title: 'Jollof Rice Kit',
    description: 'Everything you need for authentic West African jollof rice',
    productIds: ['7', '4', '5'],
    savings: 2.5,
  },
  {
    id: 'bundle-2',
    title: 'Egusi Soup Starter',
    description: 'Traditional Nigerian egusi soup ingredients',
    productIds: ['6', '4', '8', '5'],
    savings: 3.0,
  },
  {
    id: 'bundle-3',
    title: 'Ackee & Saltfish Bundle',
    description: "Jamaica's national dish essentials",
    productIds: ['16', '15', '13'],
    savings: 2.0,
  },
]
